import React from 'react';
import {MainTop} from '../group-container/main-top/Main-top';
import {ReactComponent as BackIcon} from '../../../../assets/main/groups/main-top/back.svg';
import {Details} from './tabs-content/details/Details';
import {Students} from './tabs-content/students/Students';
import {Tests} from './tabs-content/tests/Tests';
import {Homework} from './tabs-content/homework/Homework';
import {useAppSelector} from "common/hook";
import AuthWrapper from "../../../auth-wrapper/AuthWrapper";
import {ROLE_DEMO_STUDENT} from "entities/constants/constants";
import {Skeleton} from "antd";

export const Lessons = () => {
    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);
    const lessonsState = useAppSelector((state) => state.lessons.items);
    const roleType = useAppSelector((state) => state.role.roleType);
    const title = lessonsState.length > 0 ? lessonsState[0].title : <Skeleton.Input active={true}/>;

    const groupId =  lessonsState.map((el) => el.group.id)



    const mainTopProps = {
        title: title,
        tabs: false,
        setting: false,
        edit: true,
        link: roleType === ROLE_DEMO_STUDENT ? '/lessons' : `/groups/${groupId}`,
        icons: <BackIcon />,
        onlineTabs: true,
    };

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop {...mainTopProps} />
                {activeTabs.includes(0) && <Details />}
                {activeTabs.includes(1) && <Students />}
                {activeTabs.includes(2) && <Tests />}
                {activeTabs.includes(3) && <Homework />}
            </div>
        </AuthWrapper>
    );
};
